import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { transformResponseWithCurrentUserPushMessages } from 'BackRoyalApi/transformResponseWithCurrentUserPushMessages';
import {
    type ProjectGroupMembershipSansProjectGroup,
    type ProjectGroupMembershipApiResponse,
} from './ProjectGroup.types';

export const projectGroupMembershipsApi = createApi('ProjectGroupMemberships', {
    ...getBackRoyalApiBaseConfig('ProjectGroupMemberships'),
    endpoints: builder => ({
        accept: builder.mutation<ProjectGroupMembershipApiResponse, Pick<ProjectGroupMembershipSansProjectGroup, 'id'>>(
            {
                query: params => ({ method: 'put', url: `project_group_memberships/${params.id}/accept.json` }),
                transformResponse: (response: ProjectGroupMembershipApiResponse) => {
                    transformResponseWithCurrentUserPushMessages(response.meta.pushMessages);
                    return response;
                },
            },
        ),
        decline: builder.mutation<
            ProjectGroupMembershipApiResponse,
            Pick<ProjectGroupMembershipSansProjectGroup, 'id'>
        >({
            query: params => ({ method: 'put', url: `project_group_memberships/${params.id}/decline.json` }),
            transformResponse: (response: ProjectGroupMembershipApiResponse) => {
                transformResponseWithCurrentUserPushMessages(response.meta.pushMessages);
                return response;
            },
        }),
        remove: builder.mutation<ProjectGroupMembershipApiResponse, Pick<ProjectGroupMembershipSansProjectGroup, 'id'>>(
            {
                query: params => ({ method: 'put', url: `project_group_memberships/${params.id}/remove.json` }),
                transformResponse: (response: ProjectGroupMembershipApiResponse) => {
                    transformResponseWithCurrentUserPushMessages(response.meta.pushMessages);
                    return response;
                },
            },
        ),
    }),
});
